import aasaUrl from './AASAUrl';
import emailProviderBlueprint from './EmailProviderBlueprint';
import espDomainValidation from './ESPDomainValidation';
import espValidateReducer from './ESPValidate';
import generateTestLink from './GenerateTestLink';
import upsell from './Upsell';

const INIT_STATE = {
  aasaUrl: null,
  emailProviderBlueprint: null,
  espDomainValidation: null,
  espValidate: null,
  test3pLink: null,
  upsell: null,
};

export default function EmailOnboarding(state = INIT_STATE, action) {
  return {
    aasaUrl: aasaUrl(state.aasaUrl, action),
    emailProviderBlueprint: emailProviderBlueprint(state.emailProviderBlueprint, action),
    espDomainValidation: espDomainValidation(state.espDomainValidation, action),
    espValidate: espValidateReducer(state.espValidate, action),
    test3pLink: generateTestLink(state.test3pLink, action),
    upsell: upsell(state.upsell, action),
  };
}
